"use strict";

var _interopRequireWildcard = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("/Users/vagrant/git/node_modules/core-js/modules/es6.array.iterator.js");

require("/Users/vagrant/git/node_modules/core-js/modules/es6.promise.js");

require("/Users/vagrant/git/node_modules/core-js/modules/es6.object.assign.js");

require("/Users/vagrant/git/node_modules/core-js/modules/es7.promise.finally.js");

var _vue = _interopRequireDefault(require("vue"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

require("normalize.css/normalize.css");

var _elementUi = _interopRequireDefault(require("element-ui"));

var _ja = _interopRequireDefault(require("element-ui/lib/locale/lang/ja"));

require("./styles/element-variables.scss");

require("@/styles/index.scss");

var _app = _interopRequireDefault(require("firebase/app"));

require("firebase/storage");

var _App = _interopRequireDefault(require("./App"));

var _store = _interopRequireDefault(require("./store"));

var _router = _interopRequireDefault(require("./router"));

require("./icons");

require("./permission");

require("./utils/error-log");

var filters = _interopRequireWildcard(require("./filters"));

var _vueApollo = _interopRequireDefault(require("vue-apollo"));

var _apolloClient = require("@/apollo/apolloClient");

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var Integrations = _interopRequireWildcard(require("@sentry/integrations"));

require("@jledentu/vue-finder/dist/vue-finder.css");

var _vueDeviceDetector = _interopRequireDefault(require("vue-device-detector"));

var _vuejsLoadmore = _interopRequireDefault(require("vuejs-loadmore"));

var _vueLinkify = _interopRequireDefault(require("vue-linkify"));

// a modern alternative to CSS resets
// global css
// firebase
require('firebase/auth');

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_URL,
  integrations: [new Integrations.Vue({
    Vue: _vue.default,
    attachProps: true
  })]
});

_vue.default.use(_vueApollo.default);

_vue.default.use(_vueDeviceDetector.default);

_vue.default.use(_vuejsLoadmore.default);

_vue.default.directive('linkify', _vueLinkify.default);

var apolloProvider = new _vueApollo.default({
  defaultClient: _apolloClient.apolloClient
});

_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('size') || 'medium',
  // set element-ui default size
  locale: _ja.default
}); // register global utility filters


Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});

_vue.default.filter('truncate', function (value, length) {
  if (value) {
    var lengthTest = length ? parseInt(length, 10) : 20;

    if (value.length <= length) {
      return value;
    }

    return value.substring(0, lengthTest) + '...';
  }
});

new _vue.default({
  created: function created() {
    var environmentVariable = [process.env.NODE_ENV === 'production' ? 'VUE_APP_SENTRY_URL' : null, 'VUE_APP_FIREBASE_CONFIG_API_KEY', 'VUE_APP_FIREBASE_CONFIG_AUTH_DOMAIN', 'VUE_APP_FIREBASE_CONFIG_DATABASE_URL', 'VUE_APP_FIREBASE_CONFIG_PROJECT_ID', 'VUE_APP_FIREBASE_CONFIG_STORAGE_BUCKET', 'VUE_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID', 'VUE_APP_FIREBASE_CONFIG_APP_ID', 'VUE_APP_FIREBASE_CONFIG_MEASUREMENT_ID', 'VUE_APP_HASURA_URI', 'VUE_APP_CRYPT_KEY', 'VUE_APP_CRYPT_IV', 'VUE_APP_BASE_API', 'NODE_ENV'];
    var checkEnvironmentVariable = environmentVariable.filter(function (environment) {
      return !process.env[environment] && environment;
    });

    if (checkEnvironmentVariable.length !== 0) {
      console.log(checkEnvironmentVariable);
      this.$message({
        message: 'ビルド設定を確認してください。',
        type: 'error',
        duration: 50000
      });
    }
  }
});
_vue.default.config.productionTip = false; // firebaseSDK

var firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_CONFIG_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_CONFIG_MEASUREMENT_ID
}; // Initialize Firebase

_app.default.initializeApp(firebaseConfig);

_app.default.auth().onAuthStateChanged(
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(user) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!user) {
              _context.next = 4;
              break;
            }

            _store.default.dispatch('user/setFirebaseUser', user);

            _context.next = 7;
            break;

          case 4:
            _store.default.dispatch('user/setFirebaseUser', []);

            _context.next = 7;
            return _app.default.auth().signOut();

          case 7:
            new _vue.default({
              el: '#app',
              router: _router.default,
              store: _store.default,
              apolloProvider: apolloProvider,
              render: function render(h) {
                return h(_App.default);
              }
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());